// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"88a7b441","946":"1c0584e2"}[chunkId] + ".chunk.js";
};